import { computed } from "vue";
import { Capacitor } from "@capacitor/core";
import { f7 } from "framework7-vue";
import { useAuthStore } from "../pinia-stores/auth.js";
import { useAccountStore } from "../pinia-stores/account.js";
import { useKeycloakStore } from "../pinia-stores/keycloak.js";
import i18n from "../i18n.js";
import { clearIntentUrl } from "./useSessionGuard.js";

const MOBILE_URL_SCHEME =
  import.meta.env.VITE_AVOCASH_MOBILE_URL_SCHEME || "avocash://login";

 
export function useLogin() {
  const authStore = useAuthStore();
  const keycloakStore = useKeycloakStore();
  const t = i18n.global.t;
  const isNativePlatform = computed(() => authStore.isNativePlatform);
  const locale = computed(() => authStore.locale);
 function _getRedirectUri() {
        if (Capacitor.getPlatform() === "ios") {
          return import.meta.env.VITE_AVOCASH_ENABLE_IOS_UNIVERSAL_LINK === "true"
            ? import.meta.env.VITE_AVOCASH_UNIVERSAL_LINK_BASE ||
                "https://avocash.com/login"
            : import.meta.env.VITE_AVOCASH_MOBILE_URL_SCHEME || "avocash://login";
        }
        return (
          import.meta.env.VITE_AVOCASH_UNIVERSAL_LINK_BASE ||
          "https://avocash.com/login"
        );
      }
  async function withAuthFeedback(fn) {
    try {
      await fn();
    } catch (error) {
      console.error("Authentication request failed", error);
      f7.dialog.alert(
        t("common.checkConnection"),
        t("common.tryAgain"),
      );
    }
  }
  function loginFn() {
    const path = f7.views.main.router.currentRoute.path;
    const loginLocale =
      locale.value === "" ? navigator.language.split("-")[0] : locale.value;

    return withAuthFeedback(() =>
      keycloakStore.login(
        isNativePlatform.value
          ? { redirectUri: `${MOBILE_URL_SCHEME}${path}`, locale: loginLocale }
          : { redirectUri: `${window.location.origin}${path}`, locale: loginLocale },
      ),
    );
  }

  function logoutFn() {
    f7.dialog.confirm(t("common.doYouWantToLogout"), () => {
      f7.preloader.show("multi");
      clearIntentUrl();
      keycloakStore.logout(
        isNativePlatform.value
          ? { redirectUri: `${MOBILE_URL_SCHEME}/` }
          : `${window.location.origin}/`,
      );
      useAccountStore().resetAccount();
      authStore.resetProfile();
      f7.preloader.hide();
    });
  }

  function registerFn() {
    const path = f7.views.main.router.currentRoute.path;
    const loginLocale =
      locale.value === "" ? navigator.language.split("-")[0] : locale.value;

    return withAuthFeedback(() =>
      keycloakStore.register(
        isNativePlatform.value
          ? { redirectUri: `${MOBILE_URL_SCHEME}${path}`, locale: loginLocale }
          : { redirectUri: `${window.location.origin}${path}`, locale: loginLocale },
      ),
    );
  }

  return {
    loginFn,
    logoutFn,
    registerFn,
    isNativePlatform,
    locale,
  };
}
